import React,{useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Container, Button, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getPlotDetail, editPlot } from '../../../actions/plotsActions'
import { getFarms } from '../../../actions/farmsActions'
import { getCrops } from '../../../actions/cropsActions'
import FormPlot from '../../admin/plots/FormPlot'
import Swal from 'sweetalert2'

export default function PlotEdit() {     
    const { t } = useTranslation()
    const {id} = useParams()
    const {plot} = useSelector(state=>state.plots)
    const {farms} = useSelector(state=>state.farms)
    const {crops} = useSelector(state=>state.crops)
    const dispatch = useDispatch()

    const [formState, setFormState] = useState({})
    const {name, farmselected, cropsselected, idPlot} = formState

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleEdit = async(e) => {
        e.preventDefault()

        dispatch(editPlot(name, farmselected, cropsselected, idPlot))
        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('plots.messageedit')
        })
    }

    useEffect(()=>{
        dispatch(getPlotDetail(id))
        dispatch(getFarms())
        dispatch(getCrops())
    }, [dispatch,id])

    useEffect(() => {
        if (plot) {
            setFormState({
                name: plot.name,
                farmselected: plot.farm,
                cropsselected: plot.crops,
                idPlot: plot._id
            })
        }
    }, [plot, dispatch, id])
  
    return (
        <Container className='cuerpo'>
            <Row className="text-left custom-card-header-list">
                <Row className="custom-card-buttom">
                    <Button className="btn btn-secondary mb-4 mx-auto" href={`/admin/plots`}>
                        <i className="fas fa-arrow-circle-left"></i> {t('plots.volver')}
                    </Button>
                </Row>
                <h1>{t('plots.name')}: <span className='text-uppercase'>{plot?.name}</span></h1>
                <FormPlot submit={handleEdit} isNew={false} inputChange={handleInputChange} state={formState} farms={farms} crops={crops}></FormPlot>
            </Row>
        </Container>
    )
}
